export default __webpack_public_path__ + "static/media/profile5.e4c3660d.png";